import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  withStyles,
} from "@material-ui/core";

import {
  ArrowDownwardSharp,
  ArrowUpwardSharp,
  RotateLeft,
} from "@material-ui/icons";

const getLabelName = (label) => {
  switch (label) {
    case "PRAN generation Date":
      return "PRAN Generation Date";
    case "Contribution type":
      return "Contribution Type";
    case "Cont AMount":
      return "Contribution Amount";
    case "EMail ID":
      return "Email ID";
    default:
      return label;
  }
};

const MisTable = (props) => {
  const [searchDisplay, setSearchDisplay] = useState("");
  const [searchStatus, setSearchStatus] = useState(false);
  const [data, setData] = useState(props.data);
  const sortField = (label, orderBy = 1) => {
    const data = props.data;
    const comparator = (label) => {
      return function (td1, td2) {
        if (td1[label] > td2[label]) {
          return 1 * orderBy;
        } else if (td1[label] < td2[label]) {
          return -1 * orderBy;
        } else {
          return 0;
        }
      };
    };
    const sortedData = [...data].sort(comparator(label));
    setData(sortedData);
  };
  useEffect(() => {
    sortField("Subscriber Name");
  }, [props.data]);
  const keys = Object.keys(props.data[0]);
  const searchTable = (label) => (event) => {
    setIsFiltered(true);
    const value = event.target.value;
    const data = props.data;
    const searchedData = data.filter((key) =>
      key[label].toString().toLowerCase().includes(value.toLowerCase())
    );
    setData(searchedData);
    setSearchStatus(true);
  };
  const isTableEmpty = !data.length;
  const renderedData = isTableEmpty ? props.data : data;

  const [isFiltered, setIsFiltered] = useState(false);

  return (
    <>
      <div
        className="mis-table"
        style={{
          height: props.data.length < 8 ? "540px" : "",
          position: "relative",
        }}
      >
        <StyledTable stickyHeader onMouseLeave={() => setSearchDisplay("")}>
          <TableHead>
            <TableRow>
              {keys.map((key) => (
                <StyledTableCell
                  style={{ position: "relative" }}
                  onMouseEnter={() => setSearchDisplay(key)}
                >
                  <div className="d-flex justify-content-between">
                    <span>{getLabelName(key)}</span>
                    <div
                      style={{
                        visibility: "visible",
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <ArrowDownwardSharp
                          onClick={() => {
                            sortField(key, -1);
                          }}
                          style={{
                            padding: "0px",
                            height: "18px",
                            cursor: "pointer",
                            color: "black",
                          }}
                        />
                        <ArrowUpwardSharp
                          onClick={() => {
                            sortField(key);
                          }}
                          style={{
                            padding: "0px",
                            height: "18px",
                            cursor: "pointer",
                            color: "black",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          position: "absolute",
                          left: 0,
                          bottom: "-32%",
                          padding: "6px",
                          width: "100%",
                        }}
                      >
                        {searchDisplay === key && (
                          <input
                            style={{ width: "100%", height: "32px" }}
                            placeholder={`Search ${getLabelName(key)}`}
                            onChange={searchTable(key)}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          {renderedData.map((row) => (
            <TableBody
              style={{ visibility: isTableEmpty ? "hidden" : "visible" }}
            >
              <StyledTableBodyRow hover>
                {keys.map((key) => (
                  <StyledTableBodyCell
                    style={{
                      maxWidth: key === "Email ID" ? "140px" : "",
                      textAlign:
                        key === "PRAN Generation Date"
                          ? "center"
                          : key === "Contribution Amount"
                          ? "center"
                          : "",
                    }}
                  >
                    <span
                      style={{
                        fontFamily: "OpenSans-Regular",
                      }}
                    >
                      {row[key]}
                    </span>
                  </StyledTableBodyCell>
                ))}
              </StyledTableBodyRow>
            </TableBody>
          ))}
        </StyledTable>
        {searchStatus && data.length === 0 ? (
          <span
            style={{
              color: "red",
              fontFamily: "OpenSans-SemiBold",
              position: "absolute",
              left: "50%",
              top: "50%",
            }}
          >
            No Data Found
          </span>
        ) : null}
      </div>
      {isFiltered && (
        <button
          onClick={() => {
            setData(props.data);
            setIsFiltered(false);
          }}
          className="mis-reset-button"
        >
          Clear Filter
          <RotateLeft />
        </button>
      )}
    </>
  );
};

const StyledTable = withStyles((theme) => ({
  root: {
    overflowX: "auto",
  },
}))(Table);

const StyledTableCell = withStyles((theme) => ({
  root: {
    borderColor: "#fff",
    padding: "16px 0px 16px 10px",
  },
  head: {
    backgroundColor: "#007ac8;",
    color: theme.palette.common.white,
  },
}))(TableCell);

const StyledTableBodyCell = withStyles((theme) => ({
  root: {
    borderTop: "none",
    borderRight: "none",
    borderColor: "#fff",
    color: "#2f3953",
    minWidth: "180px",
    maxWidth: "240px",
  },
}))(TableCell);

const StyledTableBodyRow = withStyles((theme) => ({
  root: {
    backgroundColor: "#e5f2f9",
  },
}))(TableRow);

export default MisTable;
